// import { Decimal } from 'decimal.js'
// import { number } from 'echarts'
// 将科学计数法转换为小数
function toNonExponential(num: number): string {
    const m = num.toExponential().match(/\d(?:\.(\d*))?e([+-]\d+)/) || []
    return num.toFixed(Math.max(0, (m[1] || '').length - +m[2]))
}

// // 大于0
// function isGreaterThanZero(num: string) {
//   try {
//     if (!num) {
//       return false
//     }

//     if (new Decimal(num).greaterThan(0)) {
//       return true
//     }

//     return false
//   } catch (err) {
//     return false
//   }
// }

// 去掉小数点后0
function parseFloatNumber(val: string): string {
    if (!val) {
        return '0'
    }

    try {
        const num = parseFloat(val)
        if (isNaN(num)) {
            return val
        } else {
            return toNonExponential(num)
        }
    } catch (error) {
        return '/'
    }
}

export {
    toNonExponential,
    // isGreaterThanZero,
    parseFloatNumber
}
